module.exports = __webpack_public_path__ + "chefy-hungry-snakes.png?f259e32f182deecbfef3ff077c1855ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-hungry-snakes.png
// module id = 32
// module chunks = 0